import React from "react";
import { Link } from "react-router-dom";
import { getEmail, getMailto, LOGO, NAV } from "../lib/site";
import { OrangeArc, StripedTriangle } from "./Motifs";

const Footer = () => {
  const [email, setEmail] = React.useState("");
  const [mailto, setMailto] = React.useState("#");

  // Assemble email client-side so raw HTML source doesn't expose it plainly
  React.useEffect(() => {
    setEmail(getEmail());
    setMailto(getMailto());
  }, []);

  return (
    <footer className="relative bg-ink text-cream mt-24 overflow-hidden" data-testid="site-footer">
      <StripedTriangle className="absolute -top-8 -left-8 opacity-20" size={220} />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-12 py-20 grid md:grid-cols-12 gap-12">
        <div className="md:col-span-6">
          <Link to="/" className="flex items-center gap-3">
            <img src={LOGO} alt="Elenem Strategies" className="h-12 w-12 object-contain bg-cream p-1" />
            <span className="font-display text-2xl text-cream">
              Elenem <span className="italic text-orange-brand">Strategies</span>
            </span>
          </Link>
          <p className="font-display italic text-3xl mt-8 leading-tight max-w-md">
            Where exploration becomes innovation.
          </p>
          <p className="text-cream/70 mt-6 max-w-md text-sm leading-relaxed">
            Partnering with education, workforce, and community leaders to turn big ideas into meaningful action.
          </p>
        </div>

        <div className="md:col-span-3">
          <div className="overline text-orange-brand">Explore</div>
          <ul className="mt-4 space-y-3">
            {NAV.map((n) => (
              <li key={n.to}>
                <Link
                  to={n.to}
                  data-testid={`footer-link-${n.to.replace("/", "") || "home"}`}
                  className="text-cream/85 hover:text-orange-brand transition-colors text-sm"
                >
                  {n.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <div className="overline text-orange-brand">Reach out</div>
          <ul className="mt-4 space-y-3 text-sm">
            <li>
              <a
                href={mailto}
                data-testid="footer-email-link"
                className="text-cream/85 hover:text-orange-brand transition-colors"
              >
                Email Leah
              </a>
            </li>
            <li>
              <a
                href="tel:+19172916666"
                data-testid="footer-phone-link"
                className="text-cream/85 hover:text-orange-brand transition-colors"
              >
                Call · Text · WhatsApp
              </a>
            </li>
            <li>
              <a
                href="https://calendar.app.google/sdtkHgv3AHvTFggz9"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-schedule"
                className="text-cream/85 hover:text-orange-brand transition-colors"
              >
                Schedule a conversation
              </a>
            </li>
            <li>
              <Link
                to="/collaborate"
                data-testid="footer-collaborate"
                className="text-cream/85 hover:text-orange-brand transition-colors"
              >
                Start a conversation →
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="relative border-t border-cream/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-cream/60">
          <span>© {new Date().getFullYear()} Elenem Strategies. Curiosity is a strategy.</span>
          <Link to="/admin/login" data-testid="footer-admin" className="text-cream/40 hover:text-cream/80">
            Admin
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
